import glossary from './glossary-content';
import factors from './factors-content';
import conditions from './conditions-content';

export default {
    glossary,
    factors,
    conditions
}


// WEBPACK FOOTER //
// ./src/js/text-content/info-content.js